import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, ValidationMessage, SettingState, ValidationMessageType,
} from '@appblocks/codegeneration/types';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import Features from '@appblocks/codegeneration/Features';
import FeatureUtils from '@appblocks/codegeneration/FeatureUtils';

export default class Tibbit_45 extends BaseTibbit {
    constructor(tibbit_id: string) {
        super();
        this.id = tibbit_id;
        this.linkedFeature = 'cell';
        switch (this.id) {
            case 'tibbit_45_1':
                this.name = 'Tibbit 45_1';
                break;
            case 'tibbit_45_2':
                this.name = 'Tibbit 45_2';
                break;
            case 'tibbit_45_3':
                this.name = 'Tibbit 45_3';
                break;
            default:

                break;
        }
    }

    validate(): Array<ValidationMessage> {
        const { project } = this;
        let cellular = project.getFeature('cell');
        const messages: Array<ValidationMessage> = [];
        if (cellular === undefined) {
            cellular = FeatureUtils.getCodeItem('cell', project);
            cellular.initSettings(project);
            messages.push({
                messageType: ValidationMessageType.ADD,
                message: '',
                data: FeatureUtils.toJson(cellular),
            });
        }
        if (cellular.getSettingValue('ENABLED') !== '1') {
            messages.push({
                messageType: ValidationMessageType.UPDATE,
                message: '',
                featureId: cellular.getID(),
                settingId: 'ENABLED',
                data: '1',
            });
        }

        return messages;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/tibbit_45';
    }
}
